
import Moon from "../../../assets/filled/Moon.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MoonIcon({ className, dataTestid = "MoonIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Moon data-testid={dataTestid} className={classes} {...rest} />
  );
}
